import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTableComponent, CustomTitle, DataColumnType, DEFAULT_DATE_FORMAT, ICustomTable, ISettings } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { ITipoTramiteActividadHistorico } from '../../../../../shared/interfaces/database/configuracion';
import { DialogModule } from 'primeng/dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-admin-tipo-tramite-actividad-historial',
  standalone: true,
  imports: [DialogModule, CustomTitle, CustomTableComponent],
  templateUrl: './admin-tipo-tramite-actividad-historial.component.html',
  styleUrl: './admin-tipo-tramite-actividad-historial.component.scss',
  providers: [DatePipe]
})
export class AdminTipoTramiteActividadHistorialComponent implements OnInit {

  title: string = 'Hoja de vida Actividad Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  
  constructor(private readonly _hes: HistoricoEventoService, private readonly _t: TranslateService, private readonly datePipe: DatePipe) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividades: this._t.get('common.actividades'),
    }));
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      settings: {
        groupRows:{
          by: "cambioId",
          getHeaderValue:(data: any) => this.getHeaderValue(data)
        }
      } as ISettings,
      columns: [
        {
          field: 'actividadCodificacion',
          header: 'Actividad',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: 'Orden',
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'plazoFechaCierre',
          header: 'Plazo Fecha Cierre',
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'usuarioEvento',
          header: 'Usuario Evento',
          dataType: DataColumnType.TEXT
        }
      ]
    } as ICustomTable;

  }

  getHeaderValue(data: ITipoTramiteActividadHistorico){
    return "Fecha Actualizacion: " + this.datePipe.transform(data.fechaActualizacion, this.defaultDateFormat);
  }

  show(tipoTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(tipoTramiteId);
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(tipoTramiteId: number) {
    this._hes.getTipoTramiteActividadHistorico(tipoTramiteId).subscribe({
      next: (data: ITipoTramiteActividadHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
